import React, { useEffect, useState } from "react";
import { Table, Card, Divider } from "antd";
import { ReportServices } from "../../../Services/Reports/ReportServices";

const CardReport = () => {
  const [data, setData] = useState({
    poPayReport: [],
    proPayReport: [],
    billPayReport: [],
     inPayReport: [],
  });

  const getAllReportByPayMode = async () => {
    try {
      const request = await ReportServices.getAllReportByPayMode({
        pay_mode: "card",
      });

      setData(request.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllReportByPayMode();
  }, []);

  // -------------------------
  // NESTED TABLE COLUMNS
  // -------------------------
  const nestedColumns = [
    { title: "ID", dataIndex: "id" },
    { title: "Added On", dataIndex: "added_on" },
    { title: "Paid Amount", dataIndex: "paid_amt" },
    // { title: "Balance", dataIndex: "balance" },
    { title: "Grand Total", dataIndex: "grand_total" },
    // { title: "Pay Mode", dataIndex: "pay_mode" },
  ];

  // -------------------------
  // MAIN TABLE COLUMNS
  // -------------------------

  const poColumns = [
    { title: "PO Number", dataIndex: "po_no" },
    { title: "Total Paid", dataIndex: "total_paid" },
  ];

  const proColumns = [
    { title: "Project Number", dataIndex: "project_no" },
    { title: "Total Paid", dataIndex: "total_paid" },
  ];

  const billColumns = [
    { title: "Bill Number", dataIndex: "bill_no" },
    { title: "Total Paid", dataIndex: "total_paid" },
  ];

   const quColumns = [
    { title: "Qutotation Number", dataIndex: "qu_no" },
    { title: "Total Paid", dataIndex: "total_paid" },
  ];

  // -------------------------
  // EXPANDABLE CONFIG
  // -------------------------

  const expandableConfig = {
    expandedRowRender: (record) => (
      <Table
        columns={nestedColumns}
        dataSource={record.list}
        pagination={false}
        rowKey="id"
        size="small"
      />
    ),
    rowExpandable: (record) => record.list && record.list.length > 0,
  };

  return (
    <div style={{ padding: "20px" }}>

       <Divider style={{ borderColor: '#7cb305' }}>Income</Divider>

       <Card title="Quotation/ Invoice Payments"
        // extra={<Tag color="green" size="large">Income</Tag>}
      >
        <Table
          columns={quColumns}
          dataSource={data.inPayReport}
          expandable={expandableConfig}
          rowKey="bill_no"
        />
      </Card>

       <Divider style={{ borderColor: '#b3052eff' }}>Spend</Divider>

      {/* ---------------- PO REPORT ---------------- */}
      <Card title="Purchase Order Payments" style={{ marginBottom: 20 }}>
        <Table
          columns={poColumns}
          dataSource={data.poPayReport}
          expandable={expandableConfig}
          rowKey="po_no"
        />
      </Card>

      {/* ---------------- PROJECT REPORT ---------------- */}
      <Card title="Project Payments" style={{ marginBottom: 20 }}>
        <Table
          columns={proColumns}
          dataSource={data.proPayReport}
          expandable={expandableConfig}
          rowKey="project_no"
        />
      </Card>

      {/* ---------------- BILL REPORT ---------------- */}
      <Card title="Utility Bill Payments">
        <Table
          columns={billColumns}
          dataSource={data.billPayReport}
          expandable={expandableConfig}
          rowKey="bill_no"
        />
      </Card>
    </div>
  );
};

export default CardReport;
